import React from "react";
import ContentLayer from "./ContentLayer";

const Layers = ({ editor, height, metadata, selection, width }) => (
	<>
		<ContentLayer editor={editor} height={height} overlay={metadata.overlay} selection={selection} width={width} />
	</>
);

export default Layers;
